



export class RenderOverviewAICommand extends CustomEvent<RenderOverviewAIRequest> {
	constructor(
		element: HTMLElement,
		overviewAI: boolean,
		studyId: number,
	) {
		const detail = { element, overviewAI, studyId };
		super('', { detail });
	}
}


export interface RenderOverviewAIRequest {
	element: HTMLElement;
	overviewAI: boolean;
	studyId: number;
}